import { css, Theme } from "@emotion/react";

export const table = (theme: Theme) =>
    css({
        paddingTop: 0,
        tableLayout: "fixed",
        width: 0,
        borderCollapse: "collapse",
        borderWidth: 0,
        borderColor: theme.candy.border.color,
    });

export const fixedTableWrapper = () =>
    css({
        paddingBottom: 20,
        margin: "0 -40px",
    });

export const absoluteWrapHeader = (fixed: boolean) => () =>
    css({
        padding: !fixed ? "0 40px" : undefined,
    });

export const fixedCaption = (theme: Theme) =>
    css({
        backgroundColor: theme.candy.keyPalette.primaryBackgroundColor,
        position: "fixed",
        top: 0,
    });

export const absoluteCaption = (theme: Theme) =>
    css({
        position: "absolute",
        paddingBottom: 10,
        top: 0,
        right: 0,
        backgroundColor: theme.candy.keyPalette.primaryBackgroundColor,
    });

export const absoluteHeaderTable = (theme: Theme) =>
    css({
        borderBottom: theme.candy.tables.border.solid,
    });

export const fixedHeaderTable = (fixed: boolean) => (theme: Theme) =>
    css(
        fixed
            ? {
                  borderBottom: "none",
                  boxShadow: `0 3px 5px -3px ${theme.candy.legacy.shadowColor}`,
                  padding: "0 40px",
                  overflow: "hidden",
              }
            : {}
    );

export const headerTable = (theme: Theme) =>
    css({
        backgroundColor: theme.candy.keyPalette.primaryBackgroundColor,
        marginLeft: -80,
    });

export const captionBackground = (theme: Theme) =>
    css({
        backgroundColor: theme.candy.keyPalette.primaryBackgroundColor,
    });
